import React from 'react';
import { Button } from './ui/Button';
interface PaystackButtonProps {
  amount: number;
  email: string;
  onSuccess?: (reference: string) => void;
  onClose?: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function PaystackButton({
  amount,
  email,
  onSuccess,
  onClose,
  variant = 'primary',
  fullWidth = false,
  children
}: PaystackButtonProps) {
  const publicKey = 'pk_live_eba173b4cfa72fb00a5e6117695643fe07697f03';
  const handlePayment = () => {
    // @ts-ignore - PaystackPop is loaded via script
    const handler = window.PaystackPop?.setup({
      key: publicKey,
      email: email,
      amount: amount * 100,
      currency: 'NGN',
      ref: `${Date.now()}`,
      onClose: () => {
        if (onClose) onClose();
      },
      callback: (response: any) => {
        if (onSuccess) onSuccess(response.reference);
      }
    });
    if (handler) {
      handler.openIframe();
    } else {
      alert('Please wait for payment system to load...');
    }
  };
  return <>
      <Button variant={variant} fullWidth={fullWidth} onClick={handlePayment} data-id="element-419">
        {children}
      </Button>
    </>;
}